import { formatClockTime, parseDateOnly, toBcp47 } from '@shared/dates'
import type { Pregame } from '../types'

/** "9 PM", or "Sat 9 PM" for a festival pre-game; '' when neither is set. */
export function pregameWhenLabel(pregame: Pick<Pregame, 'day' | 'time'>, locale: string): string {
  const day = pregame.day
    ? parseDateOnly(pregame.day).toLocaleDateString(toBcp47(locale), { weekday: 'short' })
    : null
  const time = pregame.time ? formatClockTime(pregame.time, locale) : null
  return [day, time].filter(Boolean).join(' ')
}
